import script from "./BellsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BellsModal.vue?vue&type=script&setup=true&lang=js"

import "./BellsModal.vue?vue&type=style&index=0&id=1e5f20ac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e5f20ac"]])

export default __exports__